export default "__VITE_ASSET__DM8qv2NN__"